import { gql } from '@apollo/client';

import { LoginCredentials, UserResponse, RegisterCredentials, User } from './types';

import axios from '@/lib/axios';

export const loginWithEmailAndPassword = (data: LoginCredentials): Promise<UserResponse> => {
  return axios.unauthorized({ mock: false }).post('/auth/admin-login', data);
};

export const registerWithEmailAndPassword = (data: RegisterCredentials): Promise<UserResponse> => {
  return axios.unauthorized({ mock: false }).post('/auth/register', data);
};

export const getUserProfile = (): Promise<User> => {
  return axios.authorized({ mock: false }).get('/auth/me');
};

export const LOGIN_USER = gql`
  mutation Login($user: String!, $password: String!, $type: AuthenticationType!) {
    authenticateUser(input: { authenticate: { user: $user, password: $password, type: $type } }) {
      authentication {
        accessToken
        refreshToken
        fbPicture
      }
    }
  }
`;

export const GET_CURRENT_USER = gql`
  {
    currentUser {
      id
      name
      profile
      cpf
      rg
      email
      phone
      isAdmin
    }
  }
`;
